<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div>
  <app-user-header header="Verification"></app-user-header>

  <div fxLayout="row wrap" fxLayoutAlign="space-around center">
    <form [formGroup]="verificationForm">
      <div>
        <input
          id="otpfield"
          formControlName="verifyOTPControl"
          type="text"
          placeholder="Enter OTP"
          i18n-placeholder
          class="notranslate"
        /><br />
      </div>

      <app-submit-button
        id="verifyandcreate"
        buttontext="Verify and Create Account"
        (click)="verificationValidation()"
      ></app-submit-button>
      <p class="error" *ngIf="isErrorVerifyngOTP">{{ errorMessage }}</p>
    </form>

    <div class="bspacing" *ngIf="otp">OTP is {{ otp }}</div>

    <!-- For e2e testing purpose -->
    <div id="hiddenOtp" style="font-size: 0">{{ otp }}</div>
  </div>

  <div
    *ngIf="!otp"
    fxLayout="column"
    fxLayoutAlign="space-around center"
    class="spacing fsmall"
  >
    <div class="bspacing">
      OTP has been sent on registered
      {{ isEmail ? "Email." : "Mobile Number." }}
    </div>
  </div>
</div>
